interface ChatIconProps {
  isWhite?: boolean
  className?: string
}

function ChatIcon(props: ChatIconProps) {
  const { isWhite = false } = props
  const primaryColor = isWhite ? '#5B5B5B' : '#ef9747'
  return (
    <i
      className="bi bi-chat-left-dots"
      style={{
        color: primaryColor,
        width: '20px',
        fontSize: '20px',
        marginRight: '4px',
      }}
    />
  )
}

export default ChatIcon
